import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useESICDeclaration } from '../../Hooks/Features/WelcomeKit/useESICDeclaration';
import { dateConvert, renderRows } from '../../utils/Helper';
import FormTable from './FormTable';
import CommanDialog from '../CommonCompo/CommanDialog/CommanDialog';

const ESICDeclaration = ({ label, onPrev, onNext, data, readOnly }) => {

    const { formValues, showPopup, setShowPopup, fieldData, callAPI, familyData, handleDelete, insuredPersonFields, employerFields, esicIdentityField } = useESICDeclaration({ data, label })

    return (
        <div className=''>
            <section className='text-center my-2'>
                <h5 className='fw-semibold'>ESIC Declaration Form</h5>
                <p>Employees' Provident Fund Scheme, 1952 (Paragraph 34 & 57) and</p>
                <p>Employees' Pension Scheme, 1995 (Paragraph 24)</p>
                <p>(Declaration by a person taking up Employment in any Establishment on which EPF Scheme, 1952 and for EPS, 1995 is applicable)</p>
            </section>
            <div className="row align-items-stretch">
                <div className="col-md-6 d-flex flex-column">
                    <table className="table table-bordered flex-fill m-0">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th colSpan="2">(A) Insured Person's Particulars</th>
                            </tr>
                        </thead>
                        <tbody>
                            {renderRows(insuredPersonFields, formValues?.esic_option_1, "insured", 1)}
                        </tbody>
                    </table>
                </div>

                <div className="col-md-6 d-flex flex-column">
                    <table className="table table-bordered flex-fill m-0">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th colSpan="2">(B) Employer's Particulars</th>
                            </tr>
                        </thead>
                        <tbody>
                            {renderRows(employerFields, formValues?.esic_option_2, "employer", 9)}
                            <tr>
                                <td>12</td>
                                <td colSpan="2"><strong>In case of any previous employment please fill up the details as under:</strong></td>
                            </tr>
                            <tr><td>12.a</td><td>Previous Ins. No.</td><td></td></tr>
                            <tr><td>12.b</td><td>Employer's Code No.</td><td></td></tr>
                            <tr><td>12.c</td><td>Previous Employer's Name & Address</td><td></td></tr>
                        </tbody>
                    </table>
                </div>
            </div>


            {Object.entries(fieldData).map(([section, fields]) => {
                return <>
                    {fields?.isFormTable && fields?.isFormTable !== undefined &&
                        <div className='my-2'>
                            <p className='px-2' style={{ fontSize: "14px", fontWeight: "400" }}>{fields?.subTitle}</p>
                            {
                                fields?.key === "employee_esic_family_details" && <div>
                                    <FormTable onPrev={onPrev} onNext={onNext} label={label} fieldsDetails={{ [section]: fields }} data={data} IsTitle={"no"} notTable={fields?.key === "employee_esic_nominee_details"} handleAPI={callAPI} row={formValues} familyList={familyData} readOnly={readOnly} />
                                    <p className='px-2' >  I hereby decalare that the particulars given by me are correct to the best of my knowledge and belief. I undertake to intimate the corporation any changes in the membership of my family within 15 days of such change. </p>
                                </div>
                            }
                            {
                                fields?.key === "reciprocal_medical_arrangements" && <div className='px-2'>
                                    <FormTable onPrev={onPrev} onNext={onNext} label={label} fieldsDetails={{ [section]: fields }} data={data} IsTitle={"no"} notTable={fields?.key === "employee_esic_nominee_details"} handleAPI={callAPI} row={formValues} familyList={familyData} readOnly={readOnly} />

                                    <table className="table table-bordered ">
                                        <thead>
                                            <tr>
                                                <th>Name and Address of the nominee/ nominees</th>
                                                <th>Date of Birth/Age as on date of filling form </th>
                                                <th>Relationship with the Employee</th>
                                                <th>Whether residing with him/her</th>
                                                <th colSpan={2}>If 'No' state Place of Residence</th>
                                                {!readOnly && <th>Action</th>}

                                            </tr>
                                            <tr>
                                                <th colSpan={4}></th>
                                                <th colSpan={1}>Town</th>
                                                <th colSpan={1}>State</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {formValues[section]?.map((nominee, index) => {
                                                return <tr key={index}>
                                                    <td>{nominee?.member_name}</td>
                                                    <td>{dateConvert(nominee?.date_of_birth, "day-mon-year")} </td>
                                                    <td>{nominee?.relation_name}</td>
                                                    <td>{nominee?.is_residing_with_relative ? "Yes" : "No"}</td>
                                                    <td>{nominee?.is_residing_with_relative ? nominee?.residence_state : 'N/A'}</td>
                                                    <td>{nominee?.is_residing_with_relative ? nominee?.residence_town : 'N/A'}</td>
                                                    {
                                                        !readOnly && <td>  <FontAwesomeIcon
                                                            icon="fa-solid fa-trash"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => setShowPopup({ visibel: true, section, row: nominee })}
                                                        /> </td>
                                                    }
                                                </tr>
                                            })}
                                        </tbody>
                                    </table>
                                    <div>
                                        ESI Corporation Temporary Identity Card
                                        <div className='d-flex'>
                                            <div className="col-md-8 d-flex flex-column">
                                                <table className="table table-bordered flex-fill m-0">
                                                    <tbody>
                                                        {renderRows(esicIdentityField, formValues?.employee_esic_identity_card_details, "esic identity", 1)}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="col-md-4 d-flex flex-column justify-content-center border">
                                                <div className='d-flex flex-column  justify-content-center align-items-center'>
                                                    <img src={formValues?.employee_esic_identity_card_details?.user_photograph_file_id} alt='' width={100} height={100} />
                                                    <p>Employee photograph</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <section className='py-2'>
                                        <h5 className='text-center bold'>INSTRUCTIONS</h5>
                                        <ol>
                                            <li>
                                                Submission of Form-I is governed byRegulation 11 &amp; 12 of the
                                                ESI (General) Regulations, 1950.
                                            </li>
                                            <li>
                                                Family means all or any of the following relatives of an Insured Person, namely:
                                                <ol type="i">
                                                    <li>A spouse</li>
                                                    <li>A minor legitimate or adopted child dependent upon the Insured Person (I.P.)</li>
                                                    <li>
                                                        A child wholly dependent on the earnings of the I.P. and who is:
                                                        <ol type="a">
                                                            <li>Receiving education until he or she attains the age of 21 years</li>
                                                            <li>An unmarried daughter</li>
                                                        </ol>
                                                    </li>
                                                    <li>
                                                        A child who is infirm by reason of any physical or mental abnormality or injury
                                                        and is wholly dependent on the earnings of the I.P. so long as the infirmity continues
                                                    </li>
                                                    <li>Dependent parents (Please see Section 2, Clause 11 of the ESI Act, 1948 for details)</li>
                                                </ol>
                                            </li>
                                            <li>Identity Card isNon-Transferable.</li>
                                            <li>Loss of Identity Card must be reported to the Employer/Branch Manager immediately.</li>
                                            <li>
                                                Submission of false information attracts penal action under
                                                Section 84 of the ESI Act, 1948.
                                            </li>
                                            <li>
                                                This form, duly filled in, must reach the concerned Branch Office within
                                                10 days of appointment of an employee. Delay attracts penal action under
                                                Section 85 of the Act, against the employer.
                                            </li>
                                            <li>
                                                As an insured person, you and your dependent family members are entitled to full medical care.
                                                The other benefits in cash include:
                                                <ol>
                                                    <li>Sickness Benefit</li>
                                                    <li>Temporary Disablement Benefit</li>
                                                    <li>Permanent Disablement Benefit</li>
                                                    <li>Dependants Benefit</li>
                                                    <li>Maternity Benefit (in case of women employees) Subject to fulfillment of contributory conditions.</li>
                                                </ol>
                                            </li>
                                            <li>
                                                For more details, please contact the ESIC website at
                                                <a className='fw-semibold' rel="noreferrer" href="https://www.esic.org.in" target="_blank"> www.esic.org.in </a>
                                                or get in touch with the Regional Office or Branch Office.
                                            </li>
                                        </ol>
                                    </section>
                                    <p className='text-center'>For Branch Office Use only</p>
                                </div>
                            }

                            {
                                fields?.key === "reciprocal_medical_arrangements" && <div>
                                    <div className='d-flex my-4'>
                                        <div>
                                            <p>1. Date of allotment of Ins. No. :_________________________________________</p>
                                            <p> 2. Date of Issue of T.I.C. :______________________________________________</p>
                                            <p>3. Name /No. of Dispensary : ___________________________________________</p>
                                            <p>4. Whether reciprocal Medical arrangements involved. if yes, please indicate :</p>
                                        </div>

                                    </div>
                                    <FormTable onPrev={onPrev} onNext={onNext} label={label} fieldsDetails={{ [section]: fields }} data={data} IsTitle={"no"} notTable={fields?.key === "reciprocal_medical_arrangements"} handleAPI={callAPI} row={formValues} familyList={familyData} />
                                </div>
                            }
                        </div>
                    }
                </>
            }
            )}
            {
                !readOnly && <div className='d-flex gap-2 justify-content-end position-fixed w90 bottom-0 end-0 px-4 pb-2 bg-white'>
                    <button className="btn-default" onClick={onPrev}>Previous</button>
                    <button className='btn-primary' onClick={onNext}>Proceed</button>
                </div>
            }
            <CommanDialog visible={showPopup?.visibel} message={"Are you sure you want to delete this?"} handleClose={() => setShowPopup({
                visibel: false,
                section: "",
                row: ""
            })} handleFun={() => handleDelete(showPopup?.section, showPopup?.row)} />
        </div>
    )
}

export default ESICDeclaration